import type { environments } from "@dealer-center/core-enviroment";

export type OemTab = "compliance" | "scoring" | "seo";

/**
 * The one URL this page names per web component. The bundle behind it carries its own
 * environment, API base URL and build version — one build is published per environment — so
 * there is nothing else to configure and no attribute to set.
 *
 * An empty string means no artifact is published for this environment; the page renders its
 * unavailable state instead of importing nothing.
 */
type OemLoaderUrls = Record<OemTab, string>;

// One app host per domain. Local development points at the same np artifacts: each bundle
// carries its own environment, so there is no local build to serve.
const NONPROD: OemLoaderUrls = {
  compliance:
    "https://extractor.np.oem-agentic-platform.web-np.dealer.com/load.js",
  scoring: "https://scoring.np.oem-agentic-platform.web-np.dealer.com/load.js",
  seo: "https://seo.np.oem-agentic-platform.web-np.dealer.com/load.js"
};

export const OEM_LOADER_URLS: Record<environments, OemLoaderUrls> = {
  local: NONPROD,
  qa: NONPROD,
  // No production OEM hosts exist yet: site-intelligence-ui publishes one bundle per
  // environment and has no `prod` row, so there is nothing to point at. The LaunchDarkly flag
  // stays off in prod regardless.
  prod: { compliance: "", scoring: "", seo: "" }
};
